import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as paginationSelector from './pagination.selectors';
import * as paginationActions from './pagination.actions';
import { PaginationState } from './pagination.state';

@Injectable({
  providedIn: 'root',
})
export class PaginationFacadeService {
  store = inject(Store);

  pagination$: Observable<any> = this.store.select(
    paginationSelector.selectPagination
  );

  constructor() {}

  setPaginationData(pagination: PaginationState): void {
    this.store.dispatch(paginationActions.setPaginationData(pagination));
  }
}
